import { render, staticRenderFns } from "./DHRApprovalView.vue?vue&type=template&id=81821d5e&scoped=true&"
import script from "./DHRApprovalView.vue?vue&type=script&lang=js&"
export * from "./DHRApprovalView.vue?vue&type=script&lang=js&"
import style0 from "./DHRApprovalView.vue?vue&type=style&index=0&id=81821d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81821d5e",
  null
  
)

export default component.exports